// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productListLineStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsProductListLine";
import { css } from "styled-components";

productListLineStyles.descriptionGridItem = {
    width: [7, 7, 4, 4, 4],
    printWidth: 6,
    css: css`
        flex-direction: column;
    `,
}

productListLineStyles.overflowMenuGridItem = {
    width: [2, 2, 0, 0, 0],
    printWidth: 0,
    css: css`
        display: flex;
        justify-content: end;
    `
}

productListLineStyles.priceAndAvailabilityGridItem = {
    width: [12, 12, 4, 4, 5],
    printWidth: 12,
}

productListLineStyles.partNumbersGridItem = {
    width: 12,
    css: css`
        &&& {
            padding-left: 0;
        }
    `,
}

productListLineStyles.productImageStyles = {
    image: {
        height: "auto",
        width: "auto",
    },
}
productListLineStyles.productPriceStyles = {
    priceLabelText: {
        variant: "p",
        css: css`
            font-size: 14px;
            @media print {
                font-size: 12px;
            }
        `,
    },
}